/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Comment } from './Comment';
import {
    CommentFromJSON,
    CommentFromJSONTyped,
    CommentToJSON,
} from './Comment';

/**
 * 
 * @export
 * @interface ActivityReply
 */
export interface ActivityReply {
    /**
     * 
     * @type {string}
     * @memberof ActivityReply
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityReply
     */
    activityId: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityReply
     */
    activityTitle: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityReply
     */
    activityDescription: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityReply
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityReply
     */
    answererId: string;
    /**
     * 
     * @type {Array<Comment>}
     * @memberof ActivityReply
     */
    comments: Array<Comment>;
    /**
     * 
     * @type {string}
     * @memberof ActivityReply
     */
    respondContent?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ActivityReply
     */
    imagePaths: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ActivityReply
     */
    respondDate: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityReply
     */
    createAt: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityReply
     */
    answererName: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityReply
     */
    answererProfleImagePath?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ActivityReply
     */
    isUnread: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActivityReply
     */
    isResponded: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActivityReply
     */
    hasUnreadComment: boolean;
}

/**
 * Check if a given object implements the ActivityReply interface.
 */
export function instanceOfActivityReply(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "activityId" in value;
    isInstance = isInstance && "activityTitle" in value;
    isInstance = isInstance && "activityDescription" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "answererId" in value;
    isInstance = isInstance && "comments" in value;
    isInstance = isInstance && "imagePaths" in value;
    isInstance = isInstance && "respondDate" in value;
    isInstance = isInstance && "createAt" in value;
    isInstance = isInstance && "answererName" in value;
    isInstance = isInstance && "isUnread" in value;
    isInstance = isInstance && "isResponded" in value;
    isInstance = isInstance && "hasUnreadComment" in value;

    return isInstance;
}

export function ActivityReplyFromJSON(json: any): ActivityReply {
    return ActivityReplyFromJSONTyped(json, false);
}

export function ActivityReplyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityReply {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'activityId': json['activityId'],
        'activityTitle': json['activityTitle'],
        'activityDescription': json['activityDescription'],
        'userId': json['userId'],
        'answererId': json['answererId'],
        'comments': ((json['comments'] as Array<any>).map(CommentFromJSON)),
        'respondContent': !exists(json, 'respondContent') ? undefined : json['respondContent'],
        'imagePaths': json['imagePaths'],
        'respondDate': json['respondDate'],
        'createAt': json['createAt'],
        'answererName': json['answererName'],
        'answererProfleImagePath': !exists(json, 'answererProfleImagePath') ? undefined : json['answererProfleImagePath'],
        'isUnread': json['isUnread'],
        'isResponded': json['isResponded'],
        'hasUnreadComment': json['hasUnreadComment'],
    };
}

export function ActivityReplyToJSON(value?: ActivityReply | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'activityId': value.activityId,
        'activityTitle': value.activityTitle,
        'activityDescription': value.activityDescription,
        'userId': value.userId,
        'answererId': value.answererId,
        'comments': ((value.comments as Array<any>).map(CommentToJSON)),
        'respondContent': value.respondContent,
        'imagePaths': value.imagePaths,
        'respondDate': value.respondDate,
        'createAt': value.createAt,
        'answererName': value.answererName,
        'answererProfleImagePath': value.answererProfleImagePath,
        'isUnread': value.isUnread,
        'isResponded': value.isResponded,
        'hasUnreadComment': value.hasUnreadComment,
    };
}

